import * as Images from 'pos/Images';
import { selectTicket, userCanClaimTicket } from 'pos/modules/helpers/ticket-selection';
import { Command } from 'pos/common';
import * as SalesStore from '../SalesStore';
import { Result } from 'core/infrastructure';
import { Preconditions } from 'core/infrastructure-next';
import { Res, Permission } from 'core/api';
import { OrderingFacade } from 'pos/facades';
import { CustomerDisplay } from 'pos/services';
import { Message } from 'core/ui-next/modal';
import checkPendingCardTransactions from 'pos/modules/main/sale/checkPendingCardTransactions';

const title = () => Res.Web.SELECT_OPEN_TICKETS();
const icon = () => Images.SelectOpenTicket;

declare global {
	interface CommandType {
		selectOpenTicket: () => Promise<Result>
	}
}

Command.register('selectOpenTicket', Preconditions.ensure(Permission.Ticket_ViewOpened), async (): Promise<Result> => {

	let tickets = await OrderingFacade.getOpenedTickets();

	// Si el ticket actual no está en uso lo elimino de la lista
	if (SalesStore.isInitialized() && await OrderingFacade.shouldBeCancelledOrDeleted(SalesStore.getTicket().Id))
		tickets = tickets.filter(x => x.Id !== SalesStore.getTicket().Id);

	if (tickets.length === 0) {
		await Message.show(Res.Msg.MSG_THERE_IS_NOT_OPEN_TICKETS());
		return Result.error();
	}

	const result = await selectTicket({ title, icon, tickets }, 'hide-create-new-command', 'hide-ticket-commands');
	if (!result.ok)
		return Result.error();

	const canClaim = await userCanClaimTicket(result.value.ticket);
	if (!canClaim)
		return Result.error();

	await SalesStore.release();
	await SalesStore.loadTicketById(result.value.ticket.Id);

	const pendingResult = await checkPendingCardTransactions();
	if (!pendingResult.ok)
		return Result.error();

	await CustomerDisplay.displayTicketTotal(SalesStore.getTicket());

	return Result.ok();
});